import * as React from "react";
import { SVGProps } from "react";
function SvgFileTypeDefaultIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 29H6v-9h2v7h16v-7h2v9ZM6 2h20v9h-2V4H8v7H6V2Z"
        fill="#000"
        fillOpacity={0.5}
      />
      <path
        d="M7.737 12.7h4.13v1.071H9.025v1.539h2.51v1.08h-2.51V19H7.737v-6.3Zm5.152 0h1.278V19h-1.278v-6.3Zm2.723 0h1.287v5.229h2.78V19h-4.067v-6.3Zm4.86 0h4.095v1.071H21.76v1.449h2.475v1.08H21.76v1.629h2.808V19h-4.095v-6.3Z"
        fill="#000"
        fillOpacity={0.5}
      />
    </svg>
  );
}
export default SvgFileTypeDefaultIcon;
